import { TitleCasePipe } from '@angular/common';
import { inject, Injectable, Injector } from '@angular/core';

import { DialogService } from '@hglobal/fin-ui';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

import { VaultNetworkSwitchDialogComponent } from './vault-network-switch-dialog.component';
import { VaultNetworkSwitchDialogResult } from './vault-network-switch-dialog.model';

@Injectable({ providedIn: 'root' })
export class VaultNetworkSwitchDialogService {
  readonly #dialog = inject(DialogService);
  readonly #translate = inject(TranslateService);

  confirmNetworkSwitch(chainName: string, parentInjector?: Injector): Observable<boolean> {
    const dialogRef = this.#dialog.open(
      VaultNetworkSwitchDialogComponent,
      {
        title: this.#translate.instant('wallet.networkSwitch.confirm.title'),
        message: this.#translate.instant('wallet.networkSwitch.confirm.message', {
          chainName: new TitleCasePipe().transform(chainName),
        }),
        confirmLabel: this.#translate.instant('wallet.networkSwitch.confirm.confirm'),
        cancelLabel: this.#translate.instant('wallet.networkSwitch.confirm.cancel'),
      },
      {
        parentInjector,
      },
    );

    return dialogRef
      .afterClosed<VaultNetworkSwitchDialogResult | undefined>()
      .pipe(map(result => result === VaultNetworkSwitchDialogResult.Confirm));
  }
}
